import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { renderPartnerLogo, partnersContent } from './utils';

const SponsorsSection = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('memorial-language') || 'en';
    setCurrentLanguage(savedLanguage);

    // Listen for language changes
    const handleLanguageChange = (event) => {
      const newLanguage = event.detail?.language || 'en';
      setCurrentLanguage(newLanguage);
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    return () => window.removeEventListener('languageChanged', handleLanguageChange);
  }, []);

  // Strategic Sponsors
  const strategicSponsors = [];

  // Diamond Sponsors
  const diamondSponsors = [];

  // Gold Sponsors
  const goldSponsors = [];

  // Silver Sponsors
  const silverSponsors = [];

  // Technical Sponsor
  const technicalSponsors = [
    {
      id: 1,
      name: "فريق وجد الفني",
      logo: "",
      logoAlt: "فريق وجد الفني"
    }
  ];

  // Technical Partner
  const technicalPartners = [
    {
      id: 1,
      name: "QK Dev Software Services",
      logo: "/assets/images/Qk-dev-no-bg -partner-logo.png",
      logoAlt: "QK Dev Software Services logo",
      website: "https://www.qk-dev.com"
    }
  ];

  const content = partnersContent?.[currentLanguage];

  const renderSponsorCategory = (title, partners, index) => {
    const isEmpty = !partners || partners.length === 0;
    const emptyText = currentLanguage === 'ar' ? 'فارغ' : currentLanguage === 'tr' ? 'Boş' : 'Empty';
    
    return (
      <div key={index} className="text-center">
        <h4 className="text-lg md:text-xl font-semibold text-primary mb-6">
          {title}
        </h4>
        {isEmpty ? (
          <span className="text-gray-500 text-sm">{emptyText}</span>
        ) : (
          <div className="mt-4 space-y-4">
            {partners.map((partner) => (
              <div key={partner.id} className="flex flex-col items-center">
                {partner.logo && partner.logo !== "" ? (
                  <div className={`flex items-center justify-center w-full ${partner.isLarge ? 'h-32' : 'h-24'}`}>
                    {renderPartnerLogo(partner)}
                  </div>
                ) : (
                  <div className="text-base md:text-lg">{partner.name}</div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <motion.div
      id="sponsors"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="mb-24 lg:mb-32"
    >
      <h3 className="text-2xl md:text-3xl font-semibold text-primary text-center mb-6">
        {content?.sponsorsTitle}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 lg:gap-16">
        {renderSponsorCategory(content?.strategicSponsorTitle, strategicSponsors, 0)}
        {renderSponsorCategory(content?.diamondSponsorTitle, diamondSponsors, 1)}
        {renderSponsorCategory(content?.goldSponsorTitle, goldSponsors, 2)}
        {renderSponsorCategory(content?.silverSponsorTitle, silverSponsors, 3)}
        {renderSponsorCategory(content?.technicalSponsorTitle, technicalSponsors, 4)}
        {renderSponsorCategory(content?.technicalPartnerTitle, technicalPartners, 5)}
      </div>
    </motion.div>
  );
};

export default SponsorsSection;

